export default __webpack_public_path__ + "static/media/app_icon.361397f1.svg";